/* eslint-disable */
/* Автогенерация: npm start / npm run build → scripts/write-app-version.cjs */
export const CLIENT_BUILD_ID = "mo8x1ac2-b947c7da8c23d575";
export const CLIENT_APP_VERSION = "1.0.1";
